import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AcceptedFileType,
  ConversationBadgePipe,
  ConversationRoutePipe,
  ConversationUnseenPipe,
  ConversationYourExpertPipe,
  MaxFileSize,
  MaxFileSizeByType,
  MaxFilesByType,
  UnreadConversationsCountPipe,
} from './conversation.pipe';
import { InArrayPipe } from './in-array.pipe';
import {
  ChatProfileIconPipe,
  ChatSourceIconName,
  EmptyMessagesPipe,
  GetMessageMediaUrlPipe,
  IsFromYouPipe,
  IsSystemMessagePipe,
  MessageCodeBacktickPipe,
  ChatItemFromPipe,
  MessageStatusType,
  ReplaceNewLinePipe,
  ShowBookingAvailabilityPipe,
  ShowMessageButtonPipe,
  TruncateMessagePipePipe,
  ChatProfileSvgIconPipe,
} from './message.pipes';
import { FormatMessagePipe } from './format-message-pipe';
import { TrimDescriptionPipe } from './ticket-pane.pipe';
import { MessageBubbleTime, MessageTime, TimestampsPipe } from './timestamp.pipe';
import { ViewIconPipe, ViewNamePipe } from './views.pipe';

const PIPES = [
  TimestampsPipe,
  MessageStatusType,
  ConversationRoutePipe,
  ConversationBadgePipe,
  ConversationUnseenPipe,
  ConversationYourExpertPipe,
  IsSystemMessagePipe,
  ChatItemFromPipe,
  ChatSourceIconName,
  MessageCodeBacktickPipe,
  TrimDescriptionPipe,
  InArrayPipe,
  MessageTime,
  MessageBubbleTime,
  ViewIconPipe,
  ViewNamePipe,
  UnreadConversationsCountPipe,
  MaxFileSize,
  MaxFileSizeByType,
  MaxFilesByType,
  AcceptedFileType,
  GetMessageMediaUrlPipe,
  IsFromYouPipe,
  ChatProfileIconPipe,
  TruncateMessagePipePipe,
  ReplaceNewLinePipe,
  ShowBookingAvailabilityPipe,
  ShowMessageButtonPipe,
  EmptyMessagesPipe,
  ChatProfileSvgIconPipe,
  FormatMessagePipe,
];

@NgModule({
  imports: [CommonModule],
  declarations: [PIPES],
  exports: [PIPES],
})
export class ConversationPipesModule {}
